import { useGetCurrentCustomer } from 'ClientPortal/src/api/Queries/customers'
import { usePatchCurrentUser, useRemoveProfileImage, useUploadProfileImage } from 'ClientPortal/src/api/Queries/users'

export function useUserSettingsPage() {
    const { customer, isCustomerInitialLoading, isCustomerError } = useGetCurrentCustomer()
    const { mutate: patchCurrentUser, isPending: isPatchingUser } = usePatchCurrentUser()
    const { uploadProfileImage, isUploadingProfileImage } = useUploadProfileImage()
    const { removeProfileImage, isRemovingProfileImage } = useRemoveProfileImage()
    const teams = customer?.company_profile?.teams || []
    return {
        customer,
        teams,
        isCustomerInitialLoading,
        isCustomerError,
        patchCurrentUser,
        isPatchingUser,
        uploadProfileImage,
        isUploadingProfileImage,
        removeProfileImage,
        isRemovingProfileImage,
    }
}
